export class ProviderScriptLoadError extends Error {
  provider: string;

  constructor({
    message,
    provider,
  }: {
    message?: string;
    provider: "checkout" | "payPal" | "stripe";
  }) {
    super(message ?? `${provider} is not available`);
    this.name = "ProviderScriptLoadError";
    this.provider = provider;
  }
}
